import cx from 'classnames';
import styles from './index.module.css';
/**
 * @typedef {"inherit" | "none" | "capitalize" | "uppercase" | "lowercase"} textTransform
 *
 * @param textTransform {textTransform}
 * @returns - [className]
 *
 * @example
 * const [textTransformClassName] = getTextTransform('capitalize');
 */

var getTextTransform = function getTextTransform(textTransform) {
  var _cx;

  return [cx((_cx = {}, _cx[styles.inherit] = textTransform === 'inherit', _cx[styles.none] = textTransform === 'none', _cx[styles.capitalize] = textTransform === 'capitalize', _cx[styles.uppercase] = textTransform === 'uppercase', _cx[styles.lowercase] = textTransform === 'lowercase', _cx))];
};

export default getTextTransform;